import React from 'react'
import {
  ShipBoxIcon,
  JoinRightIcon,
  SwatchesIcon,
  MerchHouseholdPaperIcon,
} from '@design-systems/react-icons'

export type GroupConfig = {
  name: string
  domain: string
  icon?: React.FunctionComponent<null>
  iconColor?: string
  refineSearchLink?: string
}

export const GROUP_CONFIGS: GroupConfig[] = [
  // { name: 'Design', domain: 'DESIGN' },
  {
    name: 'Development',
    domain: 'PRODUCT_DEVELOPMENT',
    icon: ShipBoxIcon,
    iconColor: 'var(--color-data-negative-base)',
  },
  {
    name: 'Materials',
    domain: 'MATERIALS',
    icon: MerchHouseholdPaperIcon,
    iconColor: 'var(--color-background-success-base)',
  },
  {
    name: 'Combinations',
    domain: 'COMBINATIONS',
    icon: JoinRightIcon,
    iconColor: 'var(--color-data-secondary-base)',
  },
  {
    name: 'Palettes',
    domain: 'PALETTES_LOAD',
    icon: SwatchesIcon,
    iconColor: 'var(--color-data-categorical-4-base)',
  },
  // { name: 'Negotiation events', domain: 'COSTING' },
]

export const DEVELOPMENT_ACCUMULATOR_DOMAINS: string[] = [
  'PRODUCT_DEVELOPMENT',
  'Product Development',
  'BOM',
  'BOM_TEMPLATE',
  'PACKAGING_BOM',
  'PACKAGING_BOM_TEMPLATE',
  'PRODUCT',
  'PRODUCT_PLAN',
  'PRODUCT_TEMPLATE',
  'PRODUCT_WATCHLIST',
]

export const MATERIALS_ACCUMULATOR_DOMAINS: string[] = [
  'ATTACHMENT_V2',
  'ATTACHMENT',
  'ARTWORK',
  'CLAIM',
  'CLAIM_TEMPLATE',
  'COMBINATION',
  'CONSTRUCTION_SET',
  'CONSTRUCTION_SET_TEMPLATE',
  'CONSTRUCTION_TEMPLATE',
  'COLOR',
  'COLOR_ARCHROMA',
  'COLOR_COLORO',
  'COLOR_PANTONE',
  'COLORS_STANDARD_LIBRARY',
  'COLORS_REFERENCE_LIBRARY',
  'DIGITAL_FABRIC',
  'DIGITAL_FABRIC_SPEC',
  'FABRIC',
  'FABRICS',
  'FABRIC_SPEC',
  'FABRIC_SPEC_COMBO',
  'IMPRESSION_INTENT_BUCKET',
  'LD',
  'MATERIAL',
  'Materials',
  'MAPPINGS',
  'MEASUREMENT_SET',
  'MEASUREMENT_SET_TEMPLATE',
  'MEASUREMENT_TEMPLATE',
  'PACKAGING',
  'PACKAGING_SAMPLE',
  'PALETTE',
  'POM',
  'REF_COLOR',
  'REF_COLOR_ARCHROMA',
  'REF_COLOR_COLORO',
  'REF_COLOR_PANTONE',
  'SAMPLE_MEASUREMENT_SET',
  'SIZE_TEMPLATE',
  'STRUCTURAL_PACKAGING_GUIDES',
  'TAR_COLOR',
  'TAR_COLOR_ARCHROMA',
  'TAR_COLOR_COLORO',
  'TAR_COLOR_PANTONE',
  'TIGHT_FIT',
  'TEAM',
  'TRIM',
  'WASH',
  'PRODUCT_VARIATION',
  'PRODUCT_ASK',
]
